import { render, staticRenderFns } from "./verticalAlignTop.vue?vue&type=template&id=52e6cdc3&"
import script from "./verticalAlignTop.vue?vue&type=script&lang=ts&"
export * from "./verticalAlignTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports